import { DetailedHTMLProps, FC, HTMLAttributes, ReactNode } from 'react';

import classNames from 'classnames';

import './TableFooter.scss';

import { TestMetadata } from '../types';

export interface Props
  extends DetailedHTMLProps<
    HTMLAttributes<HTMLTableSectionElement>,
    HTMLTableSectionElement
  > {
  /** Table footer content */
  children?: ReactNode;
  /** Table footer classname */
  className?: string;

  sticky?: boolean;
  // Test IDs for component sections
  testMetadata?: TestMetadata;
}

const TableFooter: FC<Props> = ({
  children,
  className,
  sticky,
  testMetadata,
  ...otherProps
}) => {
  return (
    <tfoot
      {...otherProps}
      className={classNames(
        'sb-table-footer',
        sticky && 'sb-table-footer_sticky',
        className,
      )}
      {...testMetadata}
    >
      {children}
    </tfoot>
  );
};

export default TableFooter;
